import { useErrorHandler } from "~/composables/utils/useErrorHandler";

/**
 * Global client plugin: catches uncaught HTTP 409 rejections that escape the
 * SDK proxy / fetch handlers and routes them through the centralized handler,
 * which shows the "Vos droits ont été modifiés" error page (see useErrorHandler) instead
 * of logging the user out.
 */
export default defineNuxtPlugin((nuxtApp) => {
  // Client-side only plugin to listen for global errors
  if (import.meta.client) {
    const { handleHttpError } = useErrorHandler();

    // Intercept uncaught JavaScript errors (e.g. unhandled promise rejections
    // from API calls). Run within the Nuxt context so the handler can use
    // context-dependent composables (auth refresh, feedback).
    window.addEventListener("unhandledrejection", (event) => {
      const error = event.reason;

      // Check if the error is related to an HTTP 409 request
      if (error && typeof error === "object") {
        const isHandled = nuxtApp.runWithContext(() => handleHttpError(error));

        if (isHandled) {
          // Prevent error propagation if it has been handled
          event.preventDefault();
        }
      }
    });

    // Intercept global errors
    window.addEventListener("error", (event) => {
      // Check if the error comes from a fetch request
      if (event.error && typeof event.error === "object") {
        nuxtApp.runWithContext(() => handleHttpError(event.error));
      }
    });
  }
});
